module.exports = __webpack_public_path__ + "assets/pdf/CRX-bm-chart.66e0506c.pdf";